import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (role && user.role !== role) {
        const redirects = { teacher: '/teacher/dashboard', admin: '/admin/dashboard', student: '/student/dashboard' };
        return <Navigate to={redirects[user.role] || '/student/dashboard'} replace />;
    }

    return children;
}
